import { toast } from 'react-toastify'

import { api } from 'api'
import { Info, Success } from 'constants/actionMessages'
import {
  CreateAllHierarchyLevelsParams,
  RemovePromoSettingParams,
  UpdateHierarchyLevelParams,
} from 'interfaces/store/promoSettings.interfaces'
import { createAction, createAsyncThunk } from 'modules/store'
import { ValidationErrorsApi } from 'packages/api'

export const getAllHierarchyLevels = createAsyncThunk(
  'promoSettings/getAllHierarchyLevels',
  async (_, { rejectWithValue }) =>
    api.promoSettings.getAllHierarchyLevels().catch((error) => rejectWithValue(error.message)),
)

export const setHierarchyLevelsValidationErrors = createAction<ValidationErrorsApi | null>(
  'promoSettings/setHierarchyLevelsValidationErrors',
)

export const createAllHierarchyLevels = createAsyncThunk(
  'promoSettings/createAllHierarchyLevels',
  async (params: CreateAllHierarchyLevelsParams, { rejectWithValue, dispatch }) =>
    api.promoSettings
      .createAllHierarchyLevels(params.data)
      .then((data) => {
        if (params.onSuccess) {
          params.onSuccess()
        }
        dispatch(setHierarchyLevelsValidationErrors(null))
        toast.success(Success.PromoSettingHierarchyLevelCreated)
        return data
      })
      .catch((error) => {
        if (error.validation) {
          dispatch(setHierarchyLevelsValidationErrors(error.validation))
          return
        }
        return rejectWithValue(error.message)
      }),
)

export const updateHierarchyLevel = createAsyncThunk(
  'promoSettings/updateHierarchyLevel',
  async (params: UpdateHierarchyLevelParams, { rejectWithValue, dispatch }) =>
    api.promoSettings
      .updateHierarchyLevel(params.id, params.data)
      .then((data) => {
        if (params.onSuccess) {
          params.onSuccess()
        }
        dispatch(setHierarchyLevelsValidationErrors(null))
        toast.success(Success.Save)
        return data
      })
      .catch((error) => {
        if (error.validation) {
          dispatch(setHierarchyLevelsValidationErrors(error.validation))
          return
        }
        return rejectWithValue(error.message)
      }),
)

export const removeHierarchyLevel = createAsyncThunk(
  'promoSettings/removeHierarchyLevel',
  async (params: RemovePromoSettingParams, { rejectWithValue }) =>
    api.promoSettings
      .remove(params.id)
      .then(() => {
        if (params.onSuccess) {
          params.onSuccess()
        }
        toast.info(Info.PromoSettingHierarchyLevelRemoved)
        return
      })
      .catch((error) => rejectWithValue(error.message)),
)
